import React from 'react'

import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'
import {DealFreezeBannerCard} from '@vio/shared/src/dealFreeze/components/common/DealFreezeBannerCard'
import {dealFreezeOfferBoxMessages} from '@vio/shared/src/dealFreeze/components/DealFreezeOfferBox/messages'

export const DealFreezeBanner: React.FC = () => (
  <DealFreezeBannerCard
    title={
      <FormattedMessageWrapper
        id="dealFreeze.bannerFreezeDeal"
        defaultMessage="Freeze a deal"
      />
    }
    tagLabel={
      <FormattedMessageWrapper {...dealFreezeOfferBoxMessages.freezableDeal} />
    }
  >
    <FormattedMessageWrapper
      id="dealFreeze.bannerSubtitle"
      defaultMessage="Secure the price and availability, no card details required."
    />
  </DealFreezeBannerCard>
)
